export default "__VITE_ASSET__Bc5tkvo4__"